import React, { useEffect, useState } from 'react';


const Argitech4 = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  return (
   <div className='bg-white '>
     <div className='px-4 md:px-40 pt-3'>
     <h1 className="text-[14px] md:text-[36px] font-bold mt-3 text-[#FDBD26]">AgriTech</h1>
      <h1 className="text-[12px] md:text-[32px] font-bold mb-4 text-black">Revolutionizing Agriculture with Digital solutions</h1>

      <div className="relative w-full  overflow-hidden  rounded-lg bg-white">
        <div className="relative w-full rounded-lg">
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-[#742B3E] border-solid"></div>
            </div>
          )}
          <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
              alt="Play"
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[40px] h-[40px] md:w-[133px] md:h-[133px] z-10"
            />
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745008802/image_36_eupz7n.png"
            alt="Securing Agriculture in Namibia"
            className={`w-full md:h-[622px] object-cover   rounded-lg transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}
            onLoad={() => setIsLoading(false)}
          />
          {!isLoading && (
            <div className="absolute md:bottom-2 bottom-6 md:left-0 w-full px-4">
            <h2 className="text-white   md:text-[24px] font-bold mb-2">FOOD SECURITY</h2>
                <h2 className="text-white text-[14px] md:text-[40px] font-bold -mt-3" style={{ lineHeight: '1.20' }}>
                  Innovation for Sustainable <br /> Future
                </h2>
            </div>
          )}
        </div>
      </div>
      <div className="md:mt-5  mt-2 md:space-y-7 space-y-5 text-[12px] md:text-[42px] text-black font-normal leading-tight">
  {/* ...existing content here... */}
  <div className="mt-5 max-w-screen-xl w-full">
            <h3 className="text-black font-normal text-[14px] md:text-[30px] mb-1">April 13, 2025</h3>
            <div className="flex items-center gap-6 md:gap-8 text-[13px] md:text-[30px] font-normal text-black">
              <p>Story by Editorial team</p>
              <div className="flex items-center gap-2 text-[#155528]">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743893169/Time_progress_light_ecbt3q.png"
                  alt="Clock"
                  className="h-6 w-6 md:h-8 md:w-8"
                />
                <p>2 Minutes read</p>
              </div>
            </div>
          </div>
          <h2 className="font-bold mb-6">Agricultural Extension Services</h2>
          <div className=" font-sans text-[8px] md:text-[32px] text-gray-800 space-y-16 md:mt-10">
      
      <div className="mb-9 md:mt-20 mt-10">
        <p className="mt-2">
          The future of agriculture in Namibia hinges on a blend of innovative practices, technological advancements, and strategic policy initiatives aimed at enhancing resilience, sustainability, and productivity. Key drivers shaping this future include:
        </p>
      </div>

      <div className="mb-9">
        <p className="font-bold">Climate-Smart and Regenerative Agriculture</p>
        <p className="mt-2">
          With Namibia's semi-arid climate and recurring droughts, adopting climate-resilient farming practices is crucial. Techniques such as conservation agriculture (CA), which emphasizes minimal soil disturbance, permanent soil cover, and crop rotation, have shown promise in improving yields and soil health. Farmers like Petrus Shipena have reported increased harvests and income by implementing CA principles. Additionally, regenerative agriculture focuses on restoring soil fertility and enhancing biodiversity, offering long-term benefits for food security and environmental sustainability.
        </p>
      </div>

      <div className="mb-9">
        <p className="font-bold">Technological Innovation and Precision Farming</p>
        <p className="mt-2">
          The integration of technology into agriculture is transforming traditional practices. Precision farming, utilizing GPS and IoT-based sensors, allows farmers to optimize resource use and crop yields, which is particularly beneficial in Namibia's resource-constrained environment. Hydroponics and vertical farming are also gaining traction, enabling efficient food production with minimal water usage.
        </p>
      </div>

      <div className="mb-9">
        <p className="font-bold">Agroecology and Diversified Farming Systems</p>
        <p className="mt-2">
          Agroecology, which blends traditional knowledge with scientific principles, promotes sustainable farming systems that conserve water and improve soil health. In regions like north-eastern Namibia, initiatives such as the KAZA Arise project are empowering farmers to adopt agroecological techniques, enhancing resilience to climate variability.
        </p>
      </div>

      <div className="mb-9">
        <p className="font-bold">Policy Support and Institutional Frameworks</p>
        <p className="mt-2">
          Government initiatives play a pivotal role in shaping the agricultural landscape. The development of the Comprehensive Conservation Agriculture Programme (CCAP), supported by the FAO, aims to transition farmers towards climate-smart agriculture by promoting practices like minimum tillage and organic soil cover. Furthermore, Namibia's new president has pledged to diversify the economy and tackle unemployment by increasing investments in agriculture, emphasizing the sector's potential to boost domestic food production and create jobs.
        </p>
      </div>

      <div className="mb-9">
        <p className="font-bold">Sustainable Practices and Organic Farming</p>
        <p className="mt-2">
          Organic farming is gaining momentum as a sustainable alternative to conventional agriculture. Practices such as crop rotation, composting, and the use of organic fertilizers help improve soil fertility, reduce erosion, and maintain biodiversity. These methods not only enhance resilience to climate change but also offer export opportunities for Namibian produce in the global organic market.
        </p>
      </div>

      <div className="mb-9">
        <p className="font-bold">Addressing Water Scarcity and Infrastructure Development</p>
        <p className="mt-2">
          Water scarcity remains a significant challenge for Namibian agriculture. Investing in water-efficient irrigation systems and infrastructure is essential to support sustainable farming practices. The government's focus on climate-resilient infrastructure aims to mitigate the impacts of droughts and ensure long-term agricultural productivity.
        </p>
      </div>

      <div className="mb-9">
        <p className="mt-2">
        In Summary, The future of agriculture in Namibia will be shaped by a combination of innovative farming practices, technological advancements, supportive policies, and sustainable resource management. By embracing these drivers, Namibia can build a resilient and prosperous agricultural sector capable of meeting the challenges of a changing climate and global market demands.
        </p>
      </div>
    </div>
  <div className="md:h-5 h-2"></div>
</div>


    </div>
   </div>
  );
};

export default Argitech4;
